import React from 'react'

const DownloadFile = () => {
  return (
 <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
  <path d="M8 10V2" stroke="#616161" strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round"/>
  <path d="M14 10V12.6667C14 13.0203 13.8595 13.3594 13.6095 13.6095C13.3594 13.8595 13.0203 14 12.6667 14H3.33333C2.97971 14 2.64057 13.8595 2.39052 13.6095C2.14048 13.3594 2 13.0203 2 12.6667V10" stroke="#616161" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M4.66797 6.66699L8.0013 10.0003L11.3346 6.66699" stroke="#616161" strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round"/>
</svg>
  )
}

export default DownloadFile